import {
  computeProposalTotals,
  extendLineItem,
  parseDollarsToCents,
  rateToPercentDisplay,
  type Cents,
  type MarkupRate,
} from '../../shared/money.js';

export interface TotalsPreview {
  subtotalCents: Cents;
  markupCents: Cents;
  totalCents: Cents;
  markupPercentDisplay: string;
}

/**
 * Previews proposal totals while a draft is being typed, using the same exact
 * arithmetic the server uses. Malformed entries contribute nothing rather than
 * throwing, so a half-typed amount does not blank the form.
 */
export function previewProposalTotals(
  items: readonly { quantity: string; unitPrice: string }[],
  markupRate: MarkupRate = '0.0000',
): TotalsPreview {
  const amounts: Cents[] = [];

  for (const item of items) {
    const quantity = item.quantity.trim();
    if (!/^\d{1,10}(\.\d{1,4})?$/.test(quantity)) continue;
    let unitPriceCents: Cents;
    try {
      unitPriceCents = parseDollarsToCents(item.unitPrice);
    } catch {
      continue;
    }
    amounts.push(extendLineItem(quantity, unitPriceCents));
  }

  const totals = computeProposalTotals(amounts, markupRate);
  return {
    subtotalCents: totals.subtotalCents,
    markupCents: totals.markupCents,
    totalCents: totals.totalCents,
    markupPercentDisplay: `${rateToPercentDisplay(markupRate)}%`,
  };
}
